var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 16.8821,
    cy: 17.0407,
    rx: 16.3821,
    ry: 16.5714,
    fill: "#166649"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8828 19.5094C11.6641 19.5094 6.88281 23.1032 6.88281 27.0407H8.13281C8.13281 24.0719 11.8828 20.7594 16.8828 20.7594C21.8828 20.7594 25.6328 24.0719 25.6328 27.0407H26.8828C26.8828 23.1032 22.1016 19.5094 16.8828 19.5094Z",
    fill: "#004431"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7269 18.2594C16.7582 18.2594 16.7894 18.2907 16.8207 18.2907C16.8519 18.2907 16.8519 18.2907 16.8832 18.2907C16.9144 18.2907 16.9144 18.2907 16.9457 18.2907C16.9769 18.2907 17.0082 18.2907 17.0394 18.2594C19.6019 18.0719 21.6332 14.1969 21.6332 11.6032C21.5394 9.07192 19.4769 7.04067 16.9457 7.04067C16.9144 7.04067 16.8519 7.04067 16.8207 7.04067C16.7894 7.04067 16.7894 7.04067 16.7582 7.04067C14.2894 7.07192 12.2269 9.07192 12.1644 11.6344C12.1332 14.1969 14.1644 18.0719 16.7269 18.2594ZM16.8832 8.29067C18.7269 8.25942 20.3207 9.75942 20.3832 11.6344C20.3832 13.6032 18.6644 16.9469 16.8832 17.0094C15.1019 16.9469 13.3832 13.5719 13.3832 11.6344C13.4457 9.75942 15.0707 8.25942 16.8832 8.29067Z",
    fill: "#004431"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.6fdbe935a67a50d8480a14d698d9dd19.svg";
export { ForwardRef as ReactComponent };